import { render } from "./PageTataCaraDaftar.vue?vue&type=template&id=ce5fe7c6"
import script from "./PageTataCaraDaftar.vue?vue&type=script&lang=js"
export * from "./PageTataCaraDaftar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__